// extracted by mini-css-extract-plugin
module.exports = {"RemainingGuesses":"RemainingGuesses_RemainingGuesses__2ma44","text":"RemainingGuesses_text__6_w-o","number":"RemainingGuesses_number__1o5C_"};